var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWarning(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 39 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.188 31.918L18.294.694C18.564.23 19.03 0 19.5 0s.94.23 1.206.694l18.106 31.224A1.388 1.388 0 0137.606 34H1.394a1.388 1.388 0 01-1.206-2.082zm20.705-19.081a.349.349 0 00-.348-.347h-2.09a.349.349 0 00-.348.347v7.98c0 .19.157.346.348.346h2.09a.349.349 0 00.348-.347v-7.98zM19.5 28.102a2.093 2.093 0 001.45-.624 2.078 2.078 0 000-2.915 2.093 2.093 0 00-1.45-.624 2.093 2.093 0 00-1.45.624 2.078 2.078 0 000 2.915c.383.389.903.613 1.45.624z",
    fill: "#000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default ForwardRef;